import React, { useEffect, useState } from 'react';
import axios from 'axios';
import environmentConfig from '../../config/config';
import ModelViewer from './ModelViewer';
// import { getMarketFiles } from '../../utils/marketFiles';
// [당첨 축하 팝업 미리 받기] 미리 받은 상품 정보·glb Blob 사용, 응답 변환은 공용 함수
import { getCachedEntry, clearCachedEntry, toPrize } from '../../utils/rewardPrefetch';

// [당첨 축하 팝업] 이벤트 경품 성공 팝업(SocketContext, Swal) 본문
// 3D 무대(자동 회전) → EVENT REWARD / 축하합니다! / 문구 → 상품명 → 전송 정보(From·To·Token ID) → 구매관리 안내
// 3D 무대는 팝업 위·양옆 끝까지 채우고(Swal padding 0), 무대 아래 본문부터 좌우 여백(px-6) 적용
// 3D 실패 → 대표 이미지 → 🎁 순으로 대체
// [당첨 축하 팝업 미리 받기] 로딩 문구·스피너 없음 — 3D 준비 전엔 대표 이미지(없으면 무대 배경만), 3D 로드 완료 시 fade 전환
// 미리 받은 glb Blob은 blob URL로 표시하고, 언마운트(팝업 didDestroy) 때 revoke + 캐시 항목 삭제
// useAxiosApi는 오류 시 자체 Swal을 띄워 이 팝업을 대체하므로 axios 직접 호출
const STAGE_BG = 'radial-gradient(120% 90% at 50% 100%, #e7e1ff 0%, #f6f3ff 55%, #fff 100%)';

// [당첨 축하 팝업 미리 받기] 로딩 문구 제거 — 원래 코드 보존
// const LoadingStage = () => (
//   <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 pointer-events-none">
//     <div className="inline-block animate-spin rounded-full h-10 w-10 border-b-2 border-[#5a45e6]"></div>
//     <p className="text-[13px] text-gray-500">기념품을 불러오는 중</p>
//   </div>
// );

// 라벨 위, 값 아래 한 줄 (주소 전체·고정폭·줄바꿈 없음, 넘치면 가로 스크롤)
const TransferRow = ({ label, children }) => (
  <div className="px-4 py-3 text-left">
    <p className="text-[12.5px] text-gray-500">{label}</p>
    <div className="mt-1 overflow-x-auto whitespace-nowrap font-mono text-[13px] text-gray-800">{children}</div>
  </div>
);

const RewardPrizeContent = ({ marketNo, purchaseNo, sellerAddress, buyerAddress, tokenId }) => {
  // const [prize, setPrize] = useState(null); // { name, modelUrl, imageUrl }
  // const [isLoaded, setIsLoaded] = useState(false);
  // [당첨 축하 팝업 미리 받기] 팝업이 열릴 때의 캐시 항목 { prize, modelBlobPromise } — 있으면 API 재호출 없이 사용
  const [cachedEntry] = useState(() => getCachedEntry(marketNo));
  const [prize, setPrize] = useState(cachedEntry ? cachedEntry.prize : null); // { name, modelUrl, imageUrl }
  const [isLoaded, setIsLoaded] = useState(!!cachedEntry);
  const [modelSrc, setModelSrc] = useState(''); // ModelViewer에 넘길 주소 (blob URL 또는 서버 URL)
  const [isModelReady, setIsModelReady] = useState(false);
  const [isModelFailed, setIsModelFailed] = useState(false);
  const [isImageFailed, setIsImageFailed] = useState(false);

  // [당첨 축하 팝업 미리 받기] 언마운트 시 캐시 항목 삭제
  useEffect(() => () => clearCachedEntry(marketNo), [marketNo]);

  // [당첨 축하 팝업 미리 받기] glb 주소 결정 — 미리 받은 Blob이 있으면 blob URL, 없으면(null) 서버 URL
  // blob URL은 언마운트(또는 대상 변경) 때 revoke
  useEffect(() => {
    if (!prize?.modelUrl) {
      setModelSrc('');
      return undefined;
    }
    const blobPromise = cachedEntry?.modelBlobPromise;
    if (!blobPromise) {
      setModelSrc(prize.modelUrl);
      return undefined;
    }
    let cancelled = false;
    let objectUrl = '';
    blobPromise.then(blob => {
      if (cancelled) return;
      if (blob) {
        objectUrl = URL.createObjectURL(blob);
        setModelSrc(objectUrl);
      } else {
        setModelSrc(prize.modelUrl);
      }
    });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [prize, cachedEntry]);

  useEffect(() => {
    // [당첨 축하 팝업 미리 받기] 미리 받은 정보가 있으면 API 재호출 안 함
    if (cachedEntry) return undefined;
    let cancelled = false;
    // marketNo(rewardStarted)를 알면 마켓 상세(인증 불필요), 모르면 구매 상세(JWT) — 응답 필드명 동일
    const endpoint = marketNo ? `/market/${marketNo}` : purchaseNo ? `/purchase/${purchaseNo}` : null;
    if (!endpoint) {
      setIsLoaded(true);
      return undefined;
    }
    const token = localStorage.getItem('accessToken');
    axios
      .get(`${environmentConfig.apiUrl}${endpoint}`, {
        timeout: 10000,
        ...(token && { headers: { Authorization: `Bearer ${token}` } }),
      })
      .then(res => {
        const data = res.data?.data;
        if (cancelled || !data) return;
        // const files = getMarketFiles(data);
        // setPrize({ name: data.marketDataName || '', modelUrl: files.modelUrl, imageUrl: files.imageUrl });
        setPrize(toPrize(data));
      })
      .catch(error => console.error('경품 상품 조회 실패:', error))
      .finally(() => {
        if (!cancelled) setIsLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, [marketNo, purchaseNo, cachedEntry]);

  // [당첨 축하 팝업 미리 받기] 기존 무대 분기 — 원래 코드 보존
  // let stage;
  // if (!isLoaded) {
  //   stage = <LoadingStage />;
  // } else if (prize?.modelUrl && !isModelFailed) {
  //   // ModelViewer 바깥 div는 w-full h-full이므로 무대 전체를 채우도록 absolute inset-0으로 감쌈 (ModelViewer 자체는 변경 없음)
  //   stage = (
  //     <div className="absolute inset-0">
  //       <ModelViewer
  //         url={prize.modelUrl}
  //         autoRotate
  //         backgroundColor="transparent"
  //         loadingContent={<LoadingStage />}
  //         onError={() => setIsModelFailed(true)}
  //       />
  //     </div>
  //   );
  // } else if (prize?.imageUrl && !isImageFailed) {
  //   stage = (
  //     <img src={prize.imageUrl} alt={prize.name} className="max-h-full max-w-full object-contain" onError={() => setIsImageFailed(true)} />
  //   );
  // } else {
  //   stage = <span className="text-7xl" role="img" aria-label="선물">🎁</span>;
  // }

  // [당첨 축하 팝업 미리 받기] 대체 순서 3D → 이미지 → 🎁 유지
  // 조회 전: 무대 배경만 / 3D 로드 전: 대표 이미지 / 3D 로드 완료: 이미지 fade-out, 3D fade-in (300ms)
  const hasModel = isLoaded && !!prize?.modelUrl && !isModelFailed;
  const showModel = hasModel && !!modelSrc;
  const showImage = isLoaded && !!prize?.imageUrl && !isImageFailed;
  const isModelShown = showModel && isModelReady;

  const stage = (
    <>
      {showImage && (
        <div
          className={`absolute inset-0 flex items-center justify-center pointer-events-none transition-opacity duration-300 ${isModelShown ? 'opacity-0' : 'opacity-100'}`}
        >
          <img src={prize.imageUrl} alt={prize.name} className="max-h-full max-w-full object-contain" onError={() => setIsImageFailed(true)} />
        </div>
      )}
      {showModel && (
        // ModelViewer 바깥 div는 w-full h-full이므로 무대 전체를 채우도록 absolute inset-0으로 감쌈
        <div className={`absolute inset-0 transition-opacity duration-300 ${isModelShown ? 'opacity-100' : 'opacity-0'}`}>
          <ModelViewer
            url={modelSrc}
            autoRotate
            backgroundColor="transparent"
            hideLoading
            // [당첨 축하 팝업 표시 시점] load 대신 모델이 실제로 보이게 된 시점(model-visibility)에 전환 — 원래 코드 보존
            // onLoad={() => setIsModelReady(true)}
            onVisible={() => setIsModelReady(true)}
            onError={() => setIsModelFailed(true)}
          />
        </div>
      )}
      {isLoaded && !hasModel && !showImage && (
        <span className="text-7xl" role="img" aria-label="선물">🎁</span>
      )}
    </>
  );

  return (
    <div className="text-center">
      {/* 3D 무대 — 팝업 위·양옆 끝까지, 위쪽 모서리만 팝업 radius(20px)에 맞춤 */}
      <div className="relative w-full overflow-hidden rounded-t-[20px] flex items-center justify-center" style={{ height: 240, background: STAGE_BG }}>
        {stage}
      </div>

      <div className="px-6 pt-5">
        <p className="text-[12px] font-bold tracking-[0.2em] text-[#5a45e6]">EVENT REWARD</p>
        <h2 className="mt-1 text-[28px] font-bold text-gray-900">축하합니다!</h2>
        <p className="mt-1 text-[15px] text-gray-500">경품에 당첨되었습니다</p>

        {prize?.name && (
          <span className="mt-4 inline-block max-w-full break-all rounded-full bg-[#f1eefe] px-4 py-1.5 text-[14px] font-bold text-[#5a45e6]">
            {prize.name}
          </span>
        )}

        <div className="mt-5 rounded-xl border border-gray-200 divide-y divide-gray-200">
          <TransferRow label="From">{sellerAddress || '-'}</TransferRow>
          <TransferRow label="To">
            {buyerAddress || '-'}
            <span className="ml-2 inline-block rounded-full bg-[#f1eefe] px-2 py-0.5 align-middle font-sans text-[11px] font-semibold text-[#5a45e6]">내 지갑</span>
          </TransferRow>
          <TransferRow label="Token ID">{tokenId != null && tokenId !== '' ? `#${tokenId}` : '-'}</TransferRow>
        </div>

        <p className="mt-4 text-[13px] text-gray-500">
          <span className="font-semibold text-gray-700">마이페이지 &gt; 구매관리</span>에서 확인하세요
        </p>
      </div>
    </div>
  );
};

export default RewardPrizeContent;
